import EmberObject from '@ember/object';
import Em from 'ember';

export default EmberObject.extend(Em.ActionHandler);
